import React, {useEffect, useState} from 'react';
import './styles.scss';
import * as fonts from '../../util/fonts';
import colors from '../../util/colors';
import Header2 from '../../components/headers/header2';
import {Column, Row} from '../../components/layout';
import ModalTemplate from '../../components/modal';
import {compose} from 'redux';
import {connect} from 'react-redux';
import {strings} from '../../util/strings';
import {Rating} from '@mui/material';
import Icon from '../../components/icon';
import {Icons} from '../../util/icons';
import startAppointmentIcon from '../../assets/start-appointment-icon.svg';
import starIcon from '../../assets/Star.png';
import starEmptyBorder from '../../assets/star-empty-border.png';
import blackVideoIcon from '../../assets/consulta-black-video-icon.svg';
import blackEndedVideoIcon from '../../assets/consulta-acabada-black-video-icon.svg';
import startingVideoIcon from '../../assets/starting-video-icon.svg';
import noPhotoDoctor from '../../assets/medico_sem_foto.png';
import documentIcon from '../../assets/document-icon.svg';
import mbWayIcon from '../../assets/MBway.svg';
import creditCardIcon from '../../assets/CreditCard.svg';
import multiBancoIcon from '../../assets/MultiBanco.svg';
import {
  appendFormData,
  capitalizeName,
  getColor,
  possibleAppointmentStatus,
  formatPhone as formatReference,
  formatDatePhrase,
  getCurrencyCode,
  cleanProfessionalNameFromDr,
} from '../../util/utility';
import moment from 'moment';
import AppButton from '../../components/app-button';
import AppDownloadButton from '../../components/app-download-button';
import AddSharedFilesIcon from '../../components/add-shared-files-icon/AddSharedFilesIcon';
import {get, configsNoContentType, postWithCustomHeaders} from '../../api/api';
import {
  uriGetAppointmentData,
  uriUploadAppointmentFile,
  getAppointmentSpecialitiesDetail,
} from '../../api/endpoints';
import AppSpinner from '../../components/app-spinner';
import AppointmentsCancelPopup from '../appointments/components/appointments-cancel-popup/AppointmentsCancelPopup';
import AppointmentsLegalInfoModal from '../appointments/components/appointments-legal-info/AppointmentsLegalInfoModal';
import {useHistory} from 'react-router-dom';

interface AppointmentDetailsProps {
  selectedBu: any;
  showDetailsModal: boolean;
  setShowDetailsModal(value: any): void;
  labels: typeof strings.pt.appointments;
  buStyles: any;
  selectedAppointmentId: any;
  selectedAppointmentProviderId: string;
  borderColor?: any;
  setRefresh(value: any): void;
  handleStartAppointment(): void;
  language: any;
  slugFromLocation?: string;
}

interface IPaymentInfo {
  entity: string;
  reference: string;
  amount: string;
  url: string;
  paymentDataDetail?: any;
}

function AppointmentDetails({
  selectedBu,
  showDetailsModal,
  setShowDetailsModal,
  labels,
  buStyles,
  selectedAppointmentId,
  selectedAppointmentProviderId,
  borderColor,
  setRefresh,
  handleStartAppointment,
  language,
  slugFromLocation,
}: AppointmentDetailsProps) {
  const {
    BOOKED,
    PORPOSED,
    CHECKEDIN,
    PENDING,
    FULLFILED,
    NOSHOW,
    CANCELLED,
    DECLINED,
  } = possibleAppointmentStatus;
  const history = useHistory();
  const [doctorSpecialities, setDoctorSpecialities] = useState('');
  const [languages, setLanguages] = useState('');
  const [selectedFile, setSelectedFile] = useState<any>(null);
  const [appointmentData, setAppointmentData] = useState<any>(null);
  const [showError, setShowError] = useState(false);
  const [timeOutShow, setTimeOutShow] = useState(false);
  const [showCancelPopup, setShowCancelPopup] = useState(false);
  const [showChangeAlertPopup, setShowChangeAlertPopup] = useState(false);
  const [showCancelAlertPopup, setShowCancelAlertPopup] = useState(false);
  const [showLegalInfoPopup, setShowLegalInfoPopup] = useState(false);
  const [seeMore, setSeeMore] = useState(false);
  const [disableCancel, setDisableCancel] = useState(false);
  const [disableChange, setDisableChange] = useState(false);
  const [uploadingFile, setUploadingFile] = useState(false);
  const [loadingSpecialties, setLoadingSpecialties] = useState(false);
  const [showErrorUploading, setShowErrorUploading] = useState<any>(true);
  const [uploadedFile, setUploadedFile] = useState<any>(null);
  const [paymentInfo, setPaymentInfo] = useState<IPaymentInfo>({
    entity: '',
    reference: '',
    amount: '',
    url: '',
  });
  const [paymentMethod, setPaymentMethod] = useState('');
  const [paymentMethodIcons] = useState<{
    [key: string]: any;
  }>({
    cc: creditCardIcon,
    mb: multiBancoIcon,
    mbw: mbWayIcon,
  });

  const [definitelyUploadedFile, setDefinitelyUploadedFile] =
    useState<any>(null);

  const [labelSpecialtyAlertsDetails, setLabelSpecialtyAlertsDetails] =
    useState<string[]>([]);

  const featureName = 'AppointmentDetails';
  const allStrings = {...strings.pt.appointments, ...labels};

  const isPaymentDataEmpty = () => {
    return (
      paymentInfo?.amount?.length <= 0 &&
      paymentInfo?.reference?.length <= 0 &&
      paymentInfo?.entity?.length <= 0
    );
  };

  const handleChangeAppointment = () => {
    history.push({
      pathname: '/consultas-online/marcar-consulta',
      state: {
        patientList: [selectedBu],
        editingAppointmentId: appointmentData.id,
      },
    });
  };

  const checkTimeLimit = (limite: number) => {
    const timeLeft = moment(appointmentData.startTime).subtract(
      limite,
      'minutes'
    );

    const isTimeLeft = moment(new Date()).isAfter(timeLeft);
    return (
      isTimeLeft &&
      (appointmentData.status === BOOKED ||
        appointmentData.status === PORPOSED ||
        appointmentData.status === CHECKEDIN)
    );
  };

  useEffect(() => {
    if (selectedAppointmentId && showDetailsModal) {
      getAppointmentData();
    }
  }, [selectedAppointmentId, showDetailsModal]);

  useEffect(() => {
    if (appointmentData) {
      getSpecialtylabels();
      joinSpecialities(specialities);
      joinLanguages(appointmentData?.doctor.languages);
      const disableChange = checkTimeLimit(parseInt(labels?.change_limit_time));
      const disableCancel = checkTimeLimit(
        parseInt(labels?.cancellation_limit_time)
      );

      setDisableChange(disableChange);
      setDisableCancel(disableCancel);
      getPaymentInfo();
    }
  }, [appointmentData]);

  useEffect(() => {
    if (definitelyUploadedFile) {
      setDefinitelyUploadedFile(false);
      getAppointmentData();
    }
  }, [definitelyUploadedFile]);

  const getAppointmentData = async () => {
    try {
      await get(
        uriGetAppointmentData(
          selectedAppointmentProviderId,
          selectedAppointmentId
        ),
        false,
        0,
        featureName
      ).then((res: any) => {
        setAppointmentData(res?.data);
      });
    } catch (err: any) {
      setShowError(true);
      setAppointmentData(null);
    }
  };

  const showConsultaAIniciarIcon = () => {
    const status = appointmentStatusLabel(appointmentData);

    return (
      status === labels?.appointments_beginning ||
      status === labels?.appointments_began
    );
  };

  const specialities = appointmentData?.doctor?.specialties;

  const joinSpecialities = (specialities: any[]) => {
    const specialitiesNames: any[] = [];
    specialities.forEach((speciality) =>
      specialitiesNames.push(speciality.name)
    );
    const allSpecialities = specialitiesNames.join(', ');
    setDoctorSpecialities(allSpecialities);
  };

  const joinLanguages = (languages: any[]) => {
    const languagesNames: any[] = [];
    languages.forEach((language) => languagesNames.push(language.name));
    const allLanguages = languagesNames.join(', ');
    setLanguages(allLanguages);
  };

  const getPaymentInfo = () => {
    var paymentMethodIn = appointmentData?.paymentData?.paymentMethod;
    switch (paymentMethodIn) {
      case 'credit_card':
        setPaymentMethod('cc');
        break;
      case 'atm':
        setPaymentMethod('mb');
        setPaymentInfo({
          ...appointmentData?.paymentData?.paymentDataDetail,
          amount: appointmentData?.paymentData?.amount,
        });
        return;
      case 'mbway':
        setPaymentMethod('mbw');
        break;
    }
    setPaymentInfo(appointmentData?.paymentData);
  };

  const documentUpload = async (item: any, id: any) => {
    var formData = new FormData();
    const uploader = {
      id: appointmentData?.patientId,
      type: 'Patient',
    };
    formData.append('File', item);
    formData = appendFormData(uploader.id, 'Id', formData);
    formData = appendFormData(uploader.type, 'Type', formData);

    setUploadingFile(true);
    postWithCustomHeaders(
      uriUploadAppointmentFile(id, selectedAppointmentProviderId),
      formData,
      configsNoContentType(featureName)
    )
      .then((response: any) => {
        setShowErrorUploading(false);
        setDefinitelyUploadedFile(true);
      })
      .catch((error) => {
        if (error.name === 'AbortError') {
          setTimeOutShow(true);
        } else {
          setShowErrorUploading(true);
        }
      })
      .finally(() => {
        setSelectedFile(null);
        setUploadingFile(false);
        setUploadedFile(true);
      });
  };

  const getSpecialtylabels = async () => {
    try {
      setLoadingSpecialties(true);
      let resultToFormat: any = await get(
        getAppointmentSpecialitiesDetail(),
        false,
        0,
        featureName
      );
      if (slugFromLocation) {
        let alertString: any[] = []; //it's always one entry in this specific case, but using array to keep structure on render
        resultToFormat.data.items.forEach((el: any) => {
          if (el.alias === slugFromLocation) {
            el.specialtyDetails.forEach((detail: any) => {
              if (
                detail.specialtyAlertsDetailScreen &&
                detail.languageAlias === language &&
                !(
                  labelSpecialtyAlertsDetails.filter(
                    (e) => e === detail.specialtyAlertsDetailScreen
                  ).length > 0
                )
              )
                alertString.push(detail.specialtyAlertsDetailScreen);
            });
          }
        });
        setLabelSpecialtyAlertsDetails(alertString);
      } else {
        specialities.forEach((speciality: any) => {
          resultToFormat.data.items.forEach((el: any) => {
            if (el.integratorSpecialty === speciality.slug) {
              el.specialtyDetails.forEach((detail: any) => {
                if (
                  detail.specialtyAlertsDetailScreen &&
                  detail.languageAlias === language &&
                  !(
                    labelSpecialtyAlertsDetails.filter(
                      (e) => e === detail.specialtyAlertsDetailScreen
                    ).length > 0
                  )
                )
                  setLabelSpecialtyAlertsDetails(
                    (labelSpecialtyAlertsDetails) => [
                      ...labelSpecialtyAlertsDetails,
                      detail.specialtyAlertsDetailScreen,
                    ]
                  );
              });
            }
          });
        });
      }
    } catch {
      setLabelSpecialtyAlertsDetails([]);
    } finally {
      setLoadingSpecialties(false);
    }
  };

  const uploadHandler = (event: any) => {
    setSelectedFile(event.target.files[0]);
    documentUpload(event.target.files[0], appointmentData?.id);
  };

  const renderStartAppointment = () => {
    return (
      showConsultaAIniciarIcon() && (
        <AppButton
          className="appointment-details-start-appointment-button"
          variant="primary"
          onClick={() => handleStartAppointment()}>
          <img
            src={startAppointmentIcon}
            width={22}
            className="appointment-details-starting-video-icon"
          />
          <span className="bolder-text appointment-details-start-appointment-button-text">
            {labels?.appointments_detail_start_appointment}
          </span>
        </AppButton>
      )
    );
  };

  const appointmentStatusLabel = (appointment: any) => {
    let status = appointment.status;
    let startTime = appointment.startTime;

    switch (status) {
      case BOOKED:
      case PORPOSED: {
        let today = new Date();
        var duration = moment.duration(moment(startTime).diff(today));
        var minutesUntilAppointment = Math.abs(duration.asMinutes());
        if (minutesUntilAppointment > 15) {
          return labels?.appointments_confirmed;
        } else {
          return labels?.appointments_beginning;
        }
      }
      case CHECKEDIN:
        return labels?.appointments_began;
      case PENDING:
        return labels?.appointments_pending;
      case FULLFILED:
        return labels?.appointments_finished;
      case NOSHOW:
        return labels?.appointments_finished;
      case CANCELLED:
        return labels?.appointments_cancelled;
      case DECLINED:
        return labels?.appointments_cancelled;
    }
  };

  const formatDate = (date: any, phraseParts: any) => {
    return date.format(phraseParts);
  };

  const renderAppointmentDateAndStatus = () => {
    const appointmentDate: any =
      appointmentData?.startTime && moment(appointmentData.startTime);

    let today = new Date();
    let isAppointmentToday = moment(appointmentDate).isSame(today, 'day');

    let tomorrow = moment(today).add(1, 'days');
    let isAppointmentTomorrow = moment(appointmentDate).isSame(tomorrow, 'day');

    switch (appointmentStatusLabel(appointmentData)) {
      case labels?.appointments_beginning:
        return (
          <div className="appointment-details-appointment-date-status appointment-linear-gradient appointment-border-radius">
            <div>
              <img
                src={startingVideoIcon}
                width={22}
                className="appointment-details-starting-video-icon"
              />
              <span className="appointment-details-starting-soon-yellow">
                {labels?.appointments_detail_starting_soon}
              </span>
            </div>
          </div>
        );
      case labels?.appointments_began:
        return (
          <div className="appointment-details-appointment-date-status appointment-linear-gradient appointment-border-radius">
            <div>
              <img
                src={startingVideoIcon}
                width={18}
                className="appointment-details-starting-video-icon"
              />
              <span className="appointment-details-starting-soon-yellow">
                {labels?.appointments_began}
              </span>
            </div>
          </div>
        );
      case labels?.appointments_pending:
        return (
          <div className="appointment-details-appointment-date-status appointment-linear-gradient appointment-border-radius">
            <div>
              <img
                src={blackVideoIcon}
                width={18}
                className="appointment-details-black-video-icon"
              />
              <span>
                {isAppointmentToday
                  ? labels?.appointments_today +
                    formatDate(
                      appointmentDate,
                      ` [${labels?.appointments_at}] HH:mm`
                    )
                  : isAppointmentTomorrow
                  ? labels?.appointments_tomorrow +
                    formatDate(
                      appointmentDate,
                      ` [${labels?.appointments_at}] HH:mm`
                    )
                  : formatDatePhrase(
                      appointmentDate,
                      labels?.appointments_date_pattern
                    )}
              </span>
            </div>
          </div>
        );
      case labels?.appointments_confirmed:
        return (
          <>
            <div className="appointment-details-appointment-date-status-column appointment-linear-gradient appointment-border-radius no-padding">
              <div className="appointment-details-appointment-date">
                <img
                  src={blackVideoIcon}
                  width={18}
                  className="appointment-details-black-video-icon"
                />
                <span className="appointment-details-appointment-date-status-title">
                  {isAppointmentToday
                    ? labels?.appointments_today +
                      formatDate(
                        appointmentDate,
                        ` [${labels?.appointments_at}] HH:mm`
                      )
                    : isAppointmentTomorrow
                    ? labels?.appointments_tomorrow +
                      formatDate(
                        appointmentDate,
                        ` [${labels?.appointments_at}] HH:mm`
                      )
                    : formatDatePhrase(
                        appointmentDate,
                        labels?.appointments_date_pattern
                      )}
                </span>
              </div>
              {(!disableCancel || !disableChange) && (
                <div className="appointment-details-buttons-and-conditions">
                  <div>
                    <a
                      style={
                        disableChange
                          ? getColor('color', 'grey')
                          : getColor('color')
                      }
                      onClick={() => {
                        if (!disableChange) {
                          const reachedTimeLimit = checkTimeLimit(
                            parseInt(labels?.change_limit_time)
                          );
                          setDisableChange(reachedTimeLimit);
                          reachedTimeLimit
                            ? setShowChangeAlertPopup(true)
                            : handleChangeAppointment();
                        }
                      }}>
                      {labels?.appointments_detail_modify}
                    </a>
                    <span className="appointment-details-or-appointment">
                      {labels?.appointments_detail_or}
                    </span>
                    <a
                      style={
                        disableCancel
                          ? getColor('color', 'grey')
                          : getColor('color')
                      }
                      onClick={() => {
                        if (!disableCancel) {
                          const reachedTimeLimit = checkTimeLimit(
                            parseInt(labels?.cancellation_limit_time)
                          );
                          setDisableCancel(reachedTimeLimit);
                          reachedTimeLimit
                            ? setShowCancelAlertPopup(true)
                            : setShowCancelPopup(true);
                        }
                      }}>
                      {labels?.appointments_detail_cancel}
                    </a>
                    <span className="appointment-details-cancel-appointment">
                      {labels?.appointments_detail_cancel_appointment}
                    </span>
                  </div>
                  <div onClick={() => setShowLegalInfoPopup(true)}>
                    <span className="appointment-details-conditions">
                      {labels?.appointments_detail_consult_conditions}{' '}
                      <span
                        style={getColor('color')}
                        className="appointment-details-conditions-consult">
                        {labels?.appointments_detail_consult_conditions_link}
                      </span>
                    </span>
                  </div>
                </div>
              )}
            </div>
          </>
        );
      case labels?.appointments_finished:
        return (
          <>
            <div className="appointment-details-appointment-date-status appointment-linear-gradient appointment-border-radius">
              <img
                src={blackEndedVideoIcon}
                width={18}
                className="ended-appointment-details-black-video-icon"
              />
              <div>
                <span>{labels?.appointments_detail_appointment_ended}, </span>
                <span className="appointment-details-appointment-date-text">
                  {isAppointmentToday
                    ? labels?.appointments_today +
                      formatDate(
                        appointmentDate,
                        ` [${labels?.appointments_at}] HH:mm`
                      )
                    : isAppointmentTomorrow
                    ? labels?.appointments_tomorrow +
                      formatDate(
                        appointmentDate,
                        ` [${labels?.appointments_at}] HH:mm`
                      )
                    : formatDatePhrase(
                        appointmentDate,
                        labels?.appointments_date_pattern
                      )}
                </span>
              </div>
            </div>
          </>
        );
      default:
        return (
          <>
            <div className="appointment-details-appointment-date-status appointment-linear-gradient appointment-border-radius">
              <div>
                <img
                  src={blackVideoIcon}
                  width={18}
                  className="appointment-details-black-video-icon"
                />
                <span>{appointmentStatusLabel(appointmentData)}</span>
              </div>
            </div>
          </>
        );
    }
  };

  const renderPayment = () => {
    const paymentExpiresAt =
      appointmentData?.paymentData?.expiresAt &&
      formatDate(
        moment(appointmentData?.paymentData?.expiresAt),
        `[ ${labels?.appointments_until}] HH:mm`
      );

    const mbPaymentDetails =
      paymentMethod == 'mb'
        ? {
            [labels?.appointments_detail_payment_mb_entity]:
              paymentInfo['entity'],
            [labels?.appointments_detail_payment_mb_reference]: formatReference(
              paymentInfo['reference']
            ),
            [labels?.appointments_detail_payment_mb_amount]: `${parseFloat(
              paymentInfo['amount']
            ).toFixed(2)} ${getCurrencyCode(undefined, 'appointments')}`,
          }
        : {};

    const paymentMethodStrings = {
      message: eval(`labels?.appointments_detail_payment_${paymentMethod}`),
      finalize:
        paymentMethod != 'mb'
          ? eval(
              `labels?.appointments_detail_payment_finalize_${paymentMethod}`
            )
          : '',
    };

    return appointmentStatusLabel(appointmentData) ==
      labels?.appointments_pending ? (
      <div className="appointment-details-appointment-payment appointment-linear-gradient">
        <div className="appointment-details-payment-title">
          <span className="appointment-details-appointment-payment-pending">
            {labels?.appointments_pending_payment}
          </span>
          <span className="appointment-details-appointment-payment-amount">
            {parseFloat(appointmentData?.amountTotal).toFixed(2)}{' '}
            {getCurrencyCode(undefined, 'appointments')}
          </span>
        </div>
        <div className="appointment-details-payment-container">
          <div className="appointment-details-payment-way-container">
            <img
              src={paymentMethodIcons[paymentMethod]}
              className="appointment-details-payment-way-icon"
            />
            <span className="appointment-details-payment-way">
              {paymentMethodStrings['message']}
            </span>
          </div>

          {paymentMethod == 'mb' ? (
            <div className="appointment-mb-details-container">
              {Object.entries(mbPaymentDetails).map(([key, value], i) => (
                <Row className="appointment-mb-details-row" key={i}>
                  <Column className="appointment-mb-details-title">
                    <span>{key}</span>
                  </Column>
                  <Column className="appointment-mb-details-value">
                    {' '}
                    <span>{value}</span>
                  </Column>
                </Row>
              ))}
            </div>
          ) : (
            <div className="appointment-details-appointment-payment-info">
              <div className="appointment-details-payment-finish-payment">
                {paymentMethod != 'cc' ? (
                  paymentMethodStrings['finalize']
                ) : (
                  <p style={{margin: 0}}>
                    {paymentMethodStrings['finalize']}
                    <a
                      className="appointment-payment-link"
                      href={
                        paymentInfo?.paymentDataDetail?.url || paymentInfo?.url
                      }
                      target="_blank">
                      {labels?.appointments_payment_pending_confirm_cc_link}
                    </a>
                    .
                  </p>
                )}
              </div>
            </div>
          )}
          <div className="appointment-details-appointment-payment-warning">
            <div>
              <Icon
                width="24"
                height="24"
                className="appointment-details-payment-warning-icon"
                name={Icons.ALERT_PROBLEM}
                color={colors.alertRed}
              />
            </div>
            <span className="appointment-details-payment-warning-text">
              {labels?.appointments_schedule_pay_until}
              {paymentExpiresAt}{' '}
            </span>
          </div>
        </div>{' '}
      </div>
    ) : (
      <div className="appointment-details-appointment-payment appointment-linear-gradient appointment-border-radius">
        <div className="appointment-details-payment-paid-container">
          <span className="appointment-details-appointment-paid">
            {labels?.appointments_detail_payment_paid}
          </span>
          <span className="appointment-details-appointment-payment-amount">
            {parseFloat(appointmentData?.amountTotal).toFixed(2)}{' '}
            {getCurrencyCode(undefined, 'appointments')}
          </span>
        </div>
      </div>
    );
  };

  const renderMotives = () => {
    return (
      appointmentData?.symptoms && (
        <div className="appointment-details-appointment-motive appointment-linear-gradient">
          <div className="appointment-details-appointment-motive-title">
            {labels?.appointments_detail_motive}
          </div>
          <div className="appointment-details-appointment-motives">
            {appointmentData?.symptoms}
          </div>
        </div>
      )
    );
  };

  const renderSharedFiles = () => {
    const documents = appointmentData?.documents;
    const status = appointmentData?.status;

    const showAddFiles =
      status === BOOKED ||
      status === PENDING ||
      status === CHECKEDIN ||
      status === PORPOSED;

    return (
      (showAddFiles || documents) && (
        <div className="appointment-details-shared-files">
          <div className="appointment-details-shared-files-title">
            {labels?.appointments_detail_shared_files}
          </div>
          <div className="appointment-details-shared-files-container">
            {documents &&
              documents.map((document: any) => (
                <a
                  className="appointment-details-shared-files-individual-container"
                  href={document.Url}
                  target="_blank">
                  <div className="appointment-details-shared-files-individual">
                    <img src={documentIcon} width={24} />
                    <div className="appointment-details-shared-files-individual-name">
                      {document.name}
                      {/* ({document.size}MB) */}
                    </div>
                  </div>
                  <div>
                    <AppDownloadButton
                      color={buStyles?.primaryColor || colors.blue}
                    />
                  </div>
                </a>
              ))}
            {showAddFiles && (
              <label
                htmlFor="upload-file"
                id="upload-file-label"
                className="appointment-details-add-files"
                style={{opacity: uploadingFile ? '20%' : '100%'}}>
                <input
                  type="file"
                  name="file"
                  id="upload-file"
                  onChange={uploadHandler}
                />
                <div className="appointment-details-add-files-text">
                  {labels?.appointments_detail_add_files}
                </div>
                <div className="appointment-details-add-files-icon">
                  {uploadingFile ? (
                    <AppSpinner className="appointment-details-adding-files-spinner" />
                  ) : (
                    <AddSharedFilesIcon
                      color={buStyles?.primaryColor || colors.blue}
                    />
                  )}
                </div>
              </label>
            )}
          </div>
          <Column className="appointment-details-specialties-column">
            {labelSpecialtyAlertsDetails.map((label: string) => (
              <Row className="appointment-details-specialties-warning-and-input">
                <div className="appointment-specialties-warning-div">
                  <Column className="appointment-specialties-icon-column">
                    <Icon
                      width="24"
                      height="24"
                      className="appointment-details-specialties-warning-icon"
                      name={Icons.ALERT_PROBLEM}
                      color={colors.alertRed}
                      changeViewbox
                    />
                  </Column>
                  <Column>
                    <span className="appointment-slot-payment-warning-text">
                      {label}
                    </span>
                  </Column>
                </div>
              </Row>
            ))}
          </Column>
          {showErrorUploading && uploadedFile && (
            <div className="appointment-details-add-file-error">
              <Icon
                width="24"
                height="24"
                name={Icons.ALERT_PROBLEM}
                color={colors.alertRed}
              />
              <span className="error-message appointment-details-margin-left">
                {labels?.appointments_error}
              </span>
            </div>
          )}
          {timeOutShow && (
            <ModalTemplate
              type="error"
              show={timeOutShow}
              hideFooter={true}
              onHide={() => {
                setTimeOutShow(false);
              }}
              cross={true}>
              <p className="submission-problem-p" style={{color: colors.black}}>
                {labels?.appointments_timeoutError}
              </p>
              <p>{labels?.appointments_timeoutTryLater}</p>
              <Row>
                <AppButton
                  onClick={() => {
                    setTimeOutShow(false);
                  }}
                  variant="secondary"
                  className="talk-with-us-modal-button">
                  {labels?.appointments_popupConfirm}
                </AppButton>
              </Row>
            </ModalTemplate>
          )}
        </div>
      )
    );
  };

  const loadNoPhotoDoctor = (event: any) => {
    event.target.src = noPhotoDoctor;
  };

  const renderAppointmentModal = () => {
    return (
      <>
        <div className="appointment-details-id">ID {appointmentData?.id}</div>
        {renderStartAppointment()}
        <div className="appointment-details-patient-name appointment-linear-gradient appointment-border-radius">
          {labels?.appointments_detail_patient}{' '}
          <span className="bolder-text">
            {capitalizeName(appointmentData?.patientName)}
          </span>
        </div>
        <div className="appointment-details-doctor-info-container appointment-linear-gradient">
          <div className="appointment-details-doctor-info">
            <img
              src={
                appointmentData?.doctor?.photo?.normal
                  ? appointmentData?.doctor.photo?.normal
                  : noPhotoDoctor
              }
              onError={loadNoPhotoDoctor}
              className="appointment-details-doctor-image appointment-details-doctor-image-border"
              style={getColor('borderColor', borderColor)}
            />

            <div className="appointment-details-doctor-info-responsive">
              <p className="appointment-details-doctor-name">
                {cleanProfessionalNameFromDr(appointmentData?.doctorName)}
              </p>
              <p className="appointment-details-doctor-specialities">
                {doctorSpecialities}
              </p>
              <div className="appointment-details-doctor-rating">
                <Rating
                  defaultValue={
                    parseFloat(
                      appointmentData.doctor.rating
                        ? appointmentData.doctor.rating
                        : 0
                    ) / 2
                  }
                  precision={0.01}
                  readOnly
                  icon={<img src={starIcon} width={10} />}
                  emptyIcon={<img src={starEmptyBorder} width={10} />}
                />
              </div>
            </div>
          </div>
          <div className="appointment-details-doctor-curricular-info">
            <p className="appointment-details-doctor-curricular">
              {labels?.appointments_detail_curricular_info}
            </p>
            {languages && (
              <>
                <p className="appointment-details-doctor-languages-title">
                  {labels?.appointments_detail_languages}
                </p>
                <p className="appointment-details-doctor-languages">
                  {languages}{' '}
                  <span>
                    {!seeMore && appointmentData?.doctor?.academicBackground && (
                      <a
                        className="appointment-slot-see-more"
                        style={getColor('color')}
                        onClick={() => {
                          setSeeMore(true);
                        }}>
                        {allStrings.see_more}
                      </a>
                    )}
                  </span>
                </p>
              </>
            )}
            {appointmentData?.doctor?.academicBackground && seeMore && (
              <>
                <p className="appointment-details-doctor-academic-title">
                  {allStrings.appointments_detail_academic_background}
                </p>
                <p className="appointment-details-doctor-academic-info">
                  {appointmentData?.doctor.academicBackground}
                  <span>
                    {seeMore && (
                      <a
                        className="appointment-slot-see-more"
                        style={getColor('color')}
                        onClick={() => {
                          setSeeMore(false);
                        }}>
                        {allStrings.see_less}
                      </a>
                    )}
                  </span>
                </p>
              </>
            )}
          </div>
        </div>
        {renderAppointmentDateAndStatus()}
        {appointmentData?.amountTotal &&
          parseFloat(appointmentData?.amountTotal) > 0 &&
          !isPaymentDataEmpty() &&
          renderPayment()}
        {renderMotives()}
        {renderSharedFiles()}
      </>
    );
  };

  return (
    <ModalTemplate
      className="appointment-details-modal"
      inputType="confirm"
      show={showDetailsModal}
      onHide={() => {
        setShowDetailsModal(false);
      }}
      onSubmit={() => {
        setShowDetailsModal(false);
      }}
      onCancel={() => {
        setShowDetailsModal(false);
      }}
      cross={true}
      hideFooter={true}>
      <Column className="appointment-details-container">
        <Header2
          style={{...fonts.XL, color: colors.black, fontWeight: 'bolder'}}
          className="appointment-details-container-title">
          {labels?.appointments_detail_header}
        </Header2>
        {appointmentData && !loadingSpecialties ? (
          renderAppointmentModal()
        ) : (
          <div className="loading-container">
            {showError ? (
              <div className="error-message">
                <Icon
                  width="24"
                  height="24"
                  className="error-icon-general"
                  name={Icons.ALERT_PROBLEM}
                  color={colors.alertRed}
                />
                <div className="error-text-general">
                  {labels?.appointments_error}
                </div>
              </div>
            ) : (
              <AppSpinner className="appointment-detail-spinner-modal" />
            )}
          </div>
        )}
      </Column>
      {appointmentData && (
        <>
          <AppointmentsCancelPopup
            appointment={appointmentData}
            show={showCancelPopup}
            setShowModal={setShowCancelPopup}
            setShowDetailsModal={setShowDetailsModal}
            setRefresh={setRefresh}
            selectedAppointmentProviderId={selectedAppointmentProviderId}
          />
          <ModalTemplate
            type="error"
            className="change-middle-request-modal"
            show={showCancelAlertPopup || showChangeAlertPopup}
            onHide={() => {
              showCancelAlertPopup && setShowCancelAlertPopup(false);
              showChangeAlertPopup && setShowChangeAlertPopup(false);
            }}
            hideFooter={true}
            cross={true}
            title={labels?.appointments_time_expired_alert_title}>
            <p className="warningText">
              {showCancelAlertPopup &&
                `${labels?.appointments_alert_text} ${labels?.cancellation_limit_time} ${labels?.appointments_cancel_alert_text_2}`}
              {showChangeAlertPopup &&
                `${labels?.appointments_alert_text}  ${labels?.change_limit_time} ${labels?.appointments_change_alert_text_2}`}
            </p>
          </ModalTemplate>
        </>
      )}
      <AppointmentsLegalInfoModal
        setShowModal={setShowLegalInfoPopup}
        show={showLegalInfoPopup}
      />
    </ModalTemplate>
  );
}

const mapStateToProps = ({
  selectedBu,
  strings,
  globalStyles,
  language,
}: any) => ({
  selectedBu: selectedBu.value,
  labels: strings.value.pt.appointments,
  buStyles: globalStyles.value,
  language: language.value,
});

export default compose(connect(mapStateToProps)(AppointmentDetails));
